module.exports = __webpack_public_path__ + "img/icon13.026db9c5.png";